import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';

@Injectable({
  providedIn: 'root',
})
export class RedirectionService {
  constructor(
    private readonly localizeRouter: LocalizeRouterService,
    private readonly router: Router
  ) {}

  public redirect(
    routeName: string,
    extras?: NavigationExtras
  ): Promise<boolean> {
    const firstChar = routeName.charAt(0);

    if (firstChar !== '/') {
      routeName = '/' + routeName;
    }

    return this.router.navigate(
      [this.localizeRouter.translateRoute(routeName)],
      extras
    );
  }
}
